import { IValues } from "./types";

export const DEFAULT_SIGNUP_REQUIRED: IValues["required"] = {
  username: true,
  email: true,
  familyName: false,
  name: false,
  surname: false,
  company: false,
  phone: false,
};
